import {
	useMessages,
	useTranslations as useTranslationsFromPackage,
} from "@trydig/next/i18n/client";
import { resolveNestedMessage } from "./resolve-nested-message";

export * from "@trydig/next/i18n/client";

/**
 * `@trydig/next`'s translator only resolves flat top-level keys (`messages[key]`).
 * Storyblok datasource names containing a dot (e.g. `languages.en`, `geo.title`)
 * get nested into objects (`messages.languages.en`) when the messages are built,
 * so a dotted key falls through the flat lookup and echoes back as-is. This
 * wrapper falls back to a nested lookup whenever that happens.
 */
export const useTranslations = (scope?: string) => {
	const t = useTranslationsFromPackage(scope);
	const messages = useMessages();

	return (key: string, params?: Record<string, unknown>) => {
		const result = t(key, params);
		const fullKey = scope ? `${scope}.${key}` : key;

		if (result !== fullKey) return result;

		return resolveNestedMessage(messages, fullKey, params) ?? result;
	};
};
